export default __webpack_public_path__ + "static/media/signup-image.bd994738.jpg";